



















import { Component, Vue } from "vue-property-decorator";
import PublicStaffForm from "@/views/staff_survey/public_form/form.vue";

@Component({
  components: {
    PublicStaffForm,
  },
})
class StaffSurveyPublicLayout extends Vue {
  loading = false;

  async created() {
    this.loading = true;
    // alert(
    //   "This survey is for staff only. Please do not share the link with anyone else.",
    // );
    const code = (this.$route.query.code as string) || "test";
    // alert(`Your survey code is ${code}`);
    await this.$store.dispatch("staffSurvey/getStaffSurveyFormByCode", {
      code,
    });
    this.loading = false;
  }
}

export default StaffSurveyPublicLayout;
